import $ from 'jquery';

export const handleAccordian = () => {

    $(document).ready(function () {
        $('.fp-faq').on('click', 'h2', function () {
            var $faq = $(this).closest('.fp-faq');

            $faq.find('.toggle-content').slideToggle(500, function () {
                $faq.toggleClass('active');
            });
        });

        $('.fp-accordion').on('click', 'h2, .icons', function () {
            var $faq = $(this).closest('.fp-accordion');

            $faq.find('.toggle-content').slideToggle(500, function () {
                $faq.toggleClass('active');
            });
        });

        $("body").on("keypress", ".allowNumberKey", function (e) {
            var code = ("charCode" in e) ? e.charCode : e.keyCode;
            if (!(code > 47 && code < 58)) { //numeric (0-9)
                e.preventDefault();
            }
        });

        if (window.$ && window.$.fn && window.$.fn.revolution) {
            window.$('#slider1').show().revolution({
                sliderType: 'standard',
                // Add other slider options here
                responsiveLevels: [1240, 1024, 778, 480],
                gridwidth: [1170, 1024, 778, 480],
                gridheight: [600, 600, 500, 400],
                navigation: {
                    arrows: {
                        enable: true,
                        style: 'gyges', // You can change the style if needed
                        hide_onmobile: true,
                        hide_under: 600,
                    },
                },
            });
        }

        // if ($('#testimonial-slider1').length) {
        //     $('#testimonial-slider1').owlCarousel({
        //         loop: true,
        //         margin: 0,
        //         nav: true,
        //         smartSpeed: 500,
        //         autoplay: 4000,
        //         items: 1,
        //         dots: false,
        //         navText: ['<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>'],
        //         responsive: {
        //             0: {
        //                 items: 1
        //             },
        //             600: {
        //                 items: 1
        //             },
        //             800: {
        //                 items: 1
        //             },
        //             1024: {
        //                 items: 1
        //             },
        //             1200: {
        //                 items: 1
        //             }
        //         }
        //     });
        // }

        $(window).on("scroll", function () {
            // debugger;
            var n = $(".site-contact").outerHeight(!0) == undefined ? null : $(".site-contact").outerHeight(!0),
                s = $(".topbar").outerHeight(!0),
                o = n + s;

            var o = $("body").hasClass("hide-topbar-mobile") ? 0 : s;

            if ($(window).scrollTop() > o) {
                $("#masthead").addClass("minimized");
                $("#fh-header-minimized").addClass("minimized");
            } else {
                $("#masthead").removeClass("minimized");
                $("#fh-header-minimized").removeClass("minimized");
            }
        });

        $("#primary-mobile-nav").find(".menu .menu-item-has-children").prepend('<span class="toggle-children "><i class="fa fa-angle-right" aria-hidden="true"></i></span>');

        var menus = [];
        menus.push($("#primary-mobile-nav").find(".menu .menu-item-has-children"));

        menus.forEach(function (element) {
            var i = "";
            i = element.children(".dropdown-toggle").html()

            if (element.children("a").hasClass("dropdown-toggle")) {
                // element.children("ul").prepend('<li class="menu-parent-items">' + i + "</li>");
                element.children("ul").prepend('<li class="menu-back corporateBack">Back</li>');
            }

            // if (element.children("a").hasClass("toggle-children")) {
            //     $(window).parent("li").addClass("over-menu");
            //     $(window).parents(".menu").addClass("over-submenu");
            // }
            // element.find(".menu .menu-item-has-children").on("click", ".toggle-children", function (i) {
            //     i.preventDefault(), $(window).parent("li").addClass("over-menu"), $(window).parents(".menu").addClass("over-submenu")
            // })


        });

        //Hide Loading Box (Preloader)
        if ($('.preloader').length) {
            $('.preloader').delay(200).fadeOut(500);
        }

        var window_weight = $(window).width();
        if (window_weight <= 600) {
            $('.site-logo').removeClass('col-md-3 col-sm-6 col-xs-6');
            $('.site-logo').addClass('col-md-11');
            $('.site-menu').removeClass('col-md-9 col-sm-6 col-xs-6');
            $('.site-menu').addClass('col-md-1');
            $(".sliderImage").removeClass('autoscss')

        }

        // $('#liCorporateMenu').click(function () {
        //     $("#liCorporateMenu").addClass("over-menu");
        // });

        // $(".corporateBack").click(function () {
        //     $("#liCorporateMenu").removeClass("over-menu");
        // });




        // n.find(".menu .menu-item-has-children").on("click", ".toggle-children", function (i) {
        //     i.preventDefault(), e(this).parent("li").addClass("over-menu"), e(this).parents(".menu").addClass("over-submenu")
        // }), 

        // n.find(".menu .menu-item-has-children").on("click", ".menu-back", function (i) {
        //     i.preventDefault(), e(this).closest("ul").closest("li").removeClass("over-menu"), n.find(".menu .menu-item-has-children").hasClass("over-menu") || n.find(".menu").removeClass("over-submenu")
        // }), 

        // n.on("click", ".close-canvas-mobile-panel", function (e) {
        //     e.preventDefault(), i.toggleClass("display-mobile-menu")
        // })


        // $("#primary-mobile-nav").find(".menu .menu-item-has-children").prepend('<span class="toggle-children "><i class="fa fa-angle-right" aria-hidden="true"></i></span>'), $("#primary-mobile-nav").find(".menu .menu-item-has-children").each(function() {
        //     var i = "";
        //     e(this).children("a").hasClass("dropdown-toggle") && (i = e(this).children(".dropdown-toggle").html()), e(this).children("ul").prepend('<li class="menu-parent-items">' + i + "</li>"), e(this).children("ul").prepend('<li class="menu-back">' + factoryplus.factoryplus_back + "</li>")
        // }), $("#primary-mobile-nav").find(".menu .menu-item-has-children").on("click", ".toggle-children", function(i) {
        //     i.preventDefault(), e(this).parent("li").addClass("over-menu"), e(this).parents(".menu").addClass("over-submenu")
        // }), $("#primary-mobile-nav").find(".menu .menu-item-has-children").on("click", ".menu-back", function(i) {
        //     i.preventDefault(), e(this).closest("ul").closest("li").removeClass("over-menu"), $("#primary-mobile-nav").find(".menu .menu-item-has-children").hasClass("over-menu") || $("#primary-mobile-nav").find(".menu").removeClass("over-submenu")
        // }), $("#primary-mobile-nav").on("click", ".close-canvas-mobile-panel", function(e) {
        //     e.preventDefault(), i.toggleClass("display-mobile-menu")
        // })

    });
}
